<template>
  <div class="dict">
    <el-form :model="formData" :rules="rules" ref="formData" label-width="100px">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('transportDeliveryOrder.form.order') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundNo')">
                  <el-input
                    v-model="formData.outboundNo"
                    :disabled="true"
                    :placeholder="this.$t('transportDeliveryOrder.form.outboundNoPlaceholder')"
                    >>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundCreatePerson')">
                  <el-input v-model="formData.outboundCreatePersonName" :disabled="true">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundStatus')">
                  <el-input v-model="formData.outboundStatusName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.companyName')">
                  <el-tooltip
                    :disabled="!formData.companyName"
                    class="item"
                    effect="dark"
                    :content="formData.companyName"
                    placement="top"
                  >
                    <el-input v-model="formData.companyName" :disabled="true"> </el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.departmentName')">
                  <el-input v-model="formData.departmentName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundCreateDate')">
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.outboundCreateDate"
                    :disabled="true"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundPrintTime')">
                  <el-input v-model="formData.outboundPrintTime" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('transportDeliveryOrder.form.info') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6" v-if="flag == 0">
                <el-form-item
                  prop="salesLadingNo"
                  :label="this.$t('transportDeliveryOrder.form.salesLadingNo')"
                >
                  <el-input
                    v-model="formData.salesLadingNo"
                    :disabled="true"
                    :placeholder="this.$t('transportDeliveryOrder.form.salesLadingNoPlaceholder')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="flag == 1">
                <el-form-item
                  prop="allotNo"
                  :label="this.$t('transportDeliveryOrder.form.allotNo')"
                >
                  <el-input
                    v-model="formData.allotNo"
                    :disabled="true"
                    :placeholder="this.$t('transportDeliveryOrder.form.allotNoPlaceholder')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="flag == 2">
                <el-form-item
                  prop="returnAndChangeNo"
                  :label="this.$t('transportDeliveryOrder.form.returnAndChangeNo')"
                >
                  <el-input
                    v-model="formData.returnAndChangeNo"
                    :disabled="true"
                    :placeholder="
                      this.$t('transportDeliveryOrder.form.returnAndChangeNoPlaceholder')
                    "
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="deliveryMethod"
                  :label="this.$t('transportDeliveryOrder.form.deliveryMethod')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.deliveryMethod"
                    :disabled="canEdit"
                    :placeholder="this.$t('transportDeliveryOrder.form.deliveryMethodPlaceholder')"
                    filterable
                    clearable
                    @change="instructionType(formData.deliveryMethod)"
                  >
                    <el-option
                      v-for="item in instructionTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="outboundCreateTime"
                  :label="this.$t('transportDeliveryOrder.form.outboundCreateTime')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.outboundCreateTime"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    @change="changeCreatTime"
                    format="yyyy-MM-dd"
                    :placeholder="
                      this.$t('transportDeliveryOrder.form.outboundCreateTimePlaceholder')
                    "
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="validDateTo"
                  :label="this.$t('transportDeliveryOrder.form.validDateTo')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.validDateTo"
                    :disabled="canEdit"
                    :picker-options="pickerEndOptions"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('transportDeliveryOrder.form.validDateToPlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="contactPerson"
                  :label="this.$t('transportDeliveryOrder.form.contactPerson')"
                >
                  <SearchModal
                    :disabled="canEdit"
                    ref="searchModal"
                    className="customer-search"
                    :propName="person.propName"
                    :propCode="person.propCode"
                    model="contactPerson"
                    :placeholder="$t('transportDeliveryOrder.form.contactPersonPlaceholder')"
                    :API="person.API"
                    :query="person.query"
                    :page="person.page"
                    :searchColumns="person.searchColumns"
                    :columnList="person.columnList"
                    :isMultiple="true"
                    :currentValue="formData.contactPerson"
                    @setSearchModal="setContactPerson"
                  ></SearchModal>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="contactPhone"
                  :label="this.$t('transportDeliveryOrder.form.contactPhone')"
                >
                  <el-input
                    v-model="formData.contactPhone"
                    :disabled="canEdit"
                    :placeholder="this.$t('transportDeliveryOrder.form.contactPhonePlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="outboundStorageNo" label="仓库编码">
                  <el-input
                    v-model="formData.outboundStorageNo"
                    :disabled="true"
                    placeholder="请选择仓库"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="outboundStorageNo"
                  :label="this.$t('transportDeliveryOrder.form.outboundStorageNo')"
                >
                  <SearchModal
                    ref="searchModal"
                    propName="storageName"
                    className="customer-search"
                    propCode="storageCode"
                    model="outboundStorageName"
                    :placeholder="$t('transportDeliveryOrder.form.outboundStorageNoPlaceholder')"
                    :API="warehouse.API"
                    :query="warehouse.query"
                    :page="warehouse.page"
                    :searchColumns="warehouse.searchColumns"
                    :columnList="warehouse.columnList"
                    :isMultiple="true"
                    :currentValue="formData.outboundStorageName"
                    @setSearchModal="setWareHouse"
                    :disabled="true"
                  ></SearchModal>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="storageContactPhone"
                  :label="this.$t('transportDeliveryOrder.form.storageContactPhone')"
                >
                  <el-input
                    v-model="formData.storageContactPhone"
                    :disabled="canEdit"
                    :placeholder="
                      this.$t('transportDeliveryOrder.form.storageContactPhonePlaceholder')
                    "
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="outboundBusinessPerson"
                  :label="this.$t('transportDeliveryOrder.form.outboundBusinessPerson')"
                >
                  <SearchModal
                    :disabled="canEdit"
                    ref="searchModal"
                    className="customer-search"
                    :propName="person.propName"
                    :propCode="person.propCode"
                    model="outboundBusinessPerson"
                    :placeholder="
                      $t('transportDeliveryOrder.form.outboundBusinessPersonPlaceholder')
                    "
                    :API="person.API"
                    :query="person.query"
                    :page="person.page"
                    :searchColumns="person.searchColumns"
                    :columnList="person.columnList"
                    :isMultiple="true"
                    :currentValue="formData.outboundBusinessPersonName"
                    @setSearchModal="setBusinessPerson"
                  ></SearchModal>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="outboundType"
                  :label="this.$t('transportDeliveryOrder.form.outboundType')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.outboundType"
                    disabled
                    :placeholder="this.$t('transportDeliveryOrder.form.outboundTypePlaceholder')"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in outboundTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="flag != 1">
                <el-form-item
                  prop="customerNo"
                  :label="this.$t('transportDeliveryOrder.form.customerNo')"
                >
                  <SearchModal
                    :disabled="canEdit"
                    ref="searchModal"
                    propName="partnerZhName"
                    className="customer-search"
                    propCode="partnerCode"
                    model="partnerCode"
                    :placeholder="$t('transportDeliveryOrder.form.customerNoPlaceholder')"
                    :API="partner.API"
                    :query="partner.query"
                    :page="partner.page"
                    :searchColumns="partner.searchColumns"
                    :columnList="partner.columnList"
                    :isMultiple="true"
                    :currentValue="formData.customerName"
                    @setSearchModal="setCustomer"
                  ></SearchModal>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundDepartment')">
                  <el-input v-model="formData.outboundDepartmentName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.storageContactEmail')">
                  <el-input
                    v-model="formData.storageContactEmail"
                    :placeholder="this.$t('transportDeliveryOrder.form.writeStorageContactEmail')"
                    :disabled="canEdit"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('logistics.baseInformation.outCode')" prop="externalNo">
                  <!-- <el-tooltip :disabled="!baseData.mark" class="item" effect="dark" :content="baseData.mark" placement="top"> -->
                  <el-input
                    v-model="formData.externalNo"
                    :placeholder="$t('logistics.baseInformation.outCode')"
                    clearable
                    maxlength="32"
                    :disabled="canEdit"
                  ></el-input>
                  <!-- </el-tooltip> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="flag == 0">
              <el-col>
                <el-form-item prop="mark" label="备注">
                  <el-input
                    v-model="formData.mark"
                    :disabled="canEdit"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>
                <el-form-item
                  prop="deliveryNote"
                  :label="this.$t('transportDeliveryOrder.form.deliveryNote')"
                >
                  <el-input
                    v-model="formData.deliveryNote"
                    :disabled="canEdit"
                    :placeholder="this.$t('transportDeliveryOrder.form.deliveryNotePlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>
                <el-form-item label=" ">
                  <el-checkbox-group v-model="checked" @change="handleChecked" :disabled="canEdit">
                    <el-checkbox v-for="option in options" :label="option" :key="option">{{
                      option
                    }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>

    <el-collapse v-model="activeNames" class="collapse-main-content collapse-last-content">
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('transportDeliveryOrder.form.fee') }}</div
          >
        </template>
        <div class="collapse-content">
          <el-form :model="formData" :rules="rules" label-width="100px">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item
                  prop="includeOutboundExpenseData"
                  :label="this.$t('transportDeliveryOrder.form.isIncludeOutboundExpense')"
                >
                  <el-select
                    style="width: 100%"
                    filterable
                    v-model="formData.includeOutboundExpenseData"
                    :disabled="canEdit"
                    @change="changeValue"
                    :placeholder="
                      this.$t('transportDeliveryOrder.form.fisIncludeOutboundExpensePlaceholder')
                    "
                    clearable
                  >
                    <el-option
                      v-for="item in isInsureTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.isSettled')">
                  <el-checkbox v-model="formData.isSettled" :disabled="true"></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!-- 结算费用表格 -->
          <div class="tableStyle" v-show="isIncludeOutboundExpense == 0">
            <vxe-toolbar size="mini">
              <template v-slot:buttons>
                <vxe-button
                  size="medium"
                  icon="el-icon-plus"
                  class="vxe-btn-primary"
                  @click="addRow('fee')"
                  :disabled="canEdit"
                  >添加更多行记录</vxe-button
                >
                <vxe-button
                  size="medium"
                  icon="el-icon-delete"
                  class="vxe-btn-delete"
                  @click="handleDelete('fee')"
                  :disabled="canEdit"
                  >删除</vxe-button
                >
              </template>
            </vxe-toolbar>
            <vxe-grid
              border
              show-overflow
              resizable
              ref="fee"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="rowData.fee"
              :edit-rules="feeRules"
              :max-height="$store.state.app.tableHeight"
              @cell-click="(val) => rowClick(val, 'fee')"
              :edit-config="editConfigTransport"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <vxe-table-column type="checkbox" width="60"></vxe-table-column>
              <vxe-table-column
                type="index"
                width="60"
                :title="$t('table.index')"
              ></vxe-table-column>
              <vxe-table-column
                field="expenseType"
                :title="$t('transportDeliveryOrder.form.outboundExpense.expenseType')"
                :edit-render="{ name: 'ElSelect', options: expenseTypeList }"
              ></vxe-table-column>
              <vxe-table-column
                field="expenseRate"
                :title="$t('transportDeliveryOrder.form.outboundExpense.expenseRate')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <input-number-ad
                    max="99999999999.999999"
                    :precision="$globalVar.iPoint"
                    v-model="row.expenseRate"
                    @input="(val) => changeAmount(val)"
                    clearable
                  >
                  </input-number-ad>
                </template>
                <template v-slot="{ row }">
                  {{ $baseRequest.formatTableColumn(row.expenseRate, $globalVar.iPoint) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="outboundQuantity"
                :title="$t('transportDeliveryOrder.form.outboundExpense.outboundQuantity')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <input-number-ad
                    max="99999999999.999999"
                    :precision="$globalVar.qPoint"
                    v-model="row.outboundQuantity"
                    @input="(val) => changeAmount(val)"
                  >
                  </input-number-ad>
                </template>
                <template v-slot="{ row }">
                  {{ $baseRequest.formatTableColumn(row.outboundQuantity, $globalVar.qPoint) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="outboundExpense"
                :title="$t('transportDeliveryOrder.form.outboundExpense.outboundExpense')"
              >
                <template v-slot="{ row }">
                  {{ $baseRequest.formatTableColumn(row.outboundExpense) }}
                </template>
              </vxe-table-column>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('transportDeliveryOrder.form.goodInfo') }}</div
          >
        </template>
        <div class="collapse-content">
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="product"
              class="vxe-table-element"
              size="mini"
              align="center"
              :auto-resize="true"
              :data="rowData.product"
              :edit-rules="goodRules"
              :max-height="$store.state.app.tableHeight"
              @cell-click="(val) => rowClick(val, 'product')"
              :edit-config="editConfig"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <vxe-table-column
                field="productNo"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.productNo')"
              />
              <vxe-table-column
                field="productName"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.productName')"
              />
              <vxe-table-column
                field="productUnitName"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.productUnit')"
              />
              <vxe-table-column
                field="distributionBatchNo"
                width="200"
                :title="$t('transportDeliveryOrder.form.good.businessInboundBatchNo')"
              >
                <!-- <template v-slot:edit="{ row }">
                            <SearchModal
                                width="800"
                                ref="searchModal"
                                model="batchNo"
                                :placeholder='$t("transportDeliveryOrder.form.good.businessInboundBatchNoPlaceholder")'
                                :API="transportList.API"
                                :query="transportList.query"
                                :page="true"
                                :isMultiple=true
                                :currentValue="row.distributionBatchNo"
                                :columnList="transportList.columnList"
                                @setSearchModal="(val,select)=>setTransportNo(val,select,row)"
                                :disabled="flag!=2?true:canEdit"
                            ></SearchModal>
                            </template> -->
              </vxe-table-column>
              <vxe-table-column
                field="remainingOutQuantity"
                width="100"
                :title="$t('transportDeliveryOrder.copySearchTable.remainingQuantityOut')"
              >
                <template v-slot="{ row }">
                  {{ $baseRequest.formatTableColumn(row.remainingOutQuantity, $globalVar.qPoint) }}
                </template>
              </vxe-table-column>
              <vxe-table-column :title="$t('transportDeliveryOrder.form.good.businessOrder')">
                <vxe-table-column
                  field="businessOrderQuantity"
                  width="160"
                  :title="$t('transportDeliveryOrder.form.good.businessOrderQuantity')"
                >
                  <template v-slot="{ row }">
                    {{
                      $baseRequest.formatTableColumn(row.businessOrderQuantity, $globalVar.qPoint)
                    }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="businessOrderPackage"
                  width="160"
                  :title="$t('transportDeliveryOrder.form.good.businessOrderPackage')"
                >
                  <template v-slot="{ row }">
                    {{
                      $baseRequest.formatTableColumn(row.businessOrderPackage, $globalVar.qPoint)
                    }}
                  </template>
                </vxe-table-column>
              </vxe-table-column>
              <vxe-table-column :title="$t('transportDeliveryOrder.form.good.storageShouldSend')">
                <vxe-table-column
                  field="storageShouldSendQuantity"
                  width="160"
                  :title="$t('transportDeliveryOrder.form.good.storageShouldSendQuantity')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      :controls="false"
                      :max="row.maxSendQuantity"
                      :precision="$globalVar.qPoint"
                      v-model="row.storageShouldSendQuantity"
                      @input="(val) => changeSent(val, row)"
                      :disabled="canEdit"
                    >
                    </input-number-ad>
                  </template>
                  <template v-slot="{ row }">
                    {{
                      $baseRequest.formatTableColumn(
                        row.storageShouldSendQuantity,
                        $globalVar.qPoint
                      )
                    }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="storageShouldSendPackage"
                  width="160"
                  :title="$t('transportDeliveryOrder.form.good.storageShouldSendPackage')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      :controls="false"
                      :max="999999999.999999"
                      :precision="$globalVar.qPoint"
                      v-model="row.storageShouldSendPackage"
                      :disabled="canEdit"
                      @input="(val) => changeSentPack(val, row)"
                    >
                    </input-number-ad>
                  </template>
                  <template v-slot="{ row }">
                    {{
                      $baseRequest.formatTableColumn(
                        row.storageShouldSendPackage,
                        $globalVar.qPoint
                      )
                    }}
                  </template>
                </vxe-table-column>
              </vxe-table-column>
              <vxe-table-column :title="$t('transportDeliveryOrder.form.good.storageSend')">
                <vxe-table-column
                  field="storageSendQuantity"
                  width="160"
                  :title="$t('transportDeliveryOrder.form.good.storageSendQuantity')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      :controls="false"
                      :max="$cal.calCommon(row.storageShouldSendQuantity, 1.1, '*')"
                      :precision="$globalVar.qPoint"
                      v-model="row.storageSendQuantity"
                    >
                    </input-number-ad>
                  </template>
                  <template v-slot="{ row }">
                    {{ $baseRequest.formatTableColumn(row.storageSendQuantity, $globalVar.qPoint) }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="storageSendPackage"
                  width="160"
                  :title="$t('transportDeliveryOrder.form.good.storageSendPackage')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      :controls="false"
                      :max="
                        $cal.calCommon(
                          row.storageShouldSendPackage,
                          $cal.calCommon(row.storageShouldSendPackage, 0.1, '*'),
                          '+'
                        )
                      "
                      :precision="$globalVar.qPoint"
                      v-model="row.storageSendPackage"
                    >
                    </input-number-ad>
                  </template>
                  <template v-slot="{ row }">
                    {{ $baseRequest.formatTableColumn(row.storageSendPackage, $globalVar.qPoint) }}
                  </template>
                </vxe-table-column>
              </vxe-table-column>
              <vxe-table-column
                field="customerReceiveQuantity"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.customerReceiveQuantity')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <input-number-ad
                    :controls="false"
                    :max="$cal.calCommon(row.storageShouldSendQuantity, 1.1, '*')"
                    :precision="$globalVar.qPoint"
                    v-model="row.customerReceiveQuantity"
                    @input="(val) => getCustomerReceiveQuantity(val, row)"
                  >
                  </input-number-ad>
                </template>
                <template v-slot="{ row }">
                  {{
                    $baseRequest.formatTableColumn(row.customerReceiveQuantity, $globalVar.qPoint)
                  }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="nameVoyageLicense"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.nameVoyageLicense')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.nameVoyageLicense" :disabled="canEdit"></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="warehouseReceiptsNo"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.warehouseReceiptsNo')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.warehouseReceiptsNo" :disabled="canEdit"></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="mark"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.mark')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.mark" :disabled="canEdit"></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="shipComplete"
                width="160"
                :title="$t('transportDeliveryOrder.form.good.shipComplete')"
              >
                <template v-slot="{ row }">
                  <span>{{ row.shipComplete == 'Y' ? '是' : '否' }}</span>
                </template>
              </vxe-table-column>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('transportDeliveryOrder.form.transportInfo') }}</div
          >
        </template>
        <div class="collapse-content">
          <el-form :model="formData" :rules="rules" label-width="100px">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item
                  prop="shippingMethod"
                  :label="this.$t('transportDeliveryOrder.form.shippingMethod')"
                  label-width="70px"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.shippingMethod"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('transportDeliveryOrder.form.shippingMethodPlaceholder')"
                    clearable
                  >
                    <el-option
                      v-for="item in deliveryMethodList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!-- 出库费用表格 -->
          <div class="tableStyle">
            <vxe-toolbar size="mini">
              <template v-slot:buttons>
                <vxe-button
                  :disabled="canEdit"
                  size="medium"
                  icon="el-icon-plus"
                  class="vxe-btn-primary"
                  @click="addRow('transport')"
                  >添加更多行记录</vxe-button
                >
                <vxe-button
                  :disabled="canEdit"
                  size="medium"
                  icon="el-icon-delete"
                  class="vxe-btn-delete"
                  @click="handleDelete('transport')"
                  >删除</vxe-button
                >
              </template>
            </vxe-toolbar>
            <vxe-grid
              border
              show-overflow
              resizable
              ref="transport"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="rowData.transport"
              :edit-rules="transportRules"
              :max-height="$store.state.app.tableHeight"
              @cell-click="(val) => rowClick(val, 'transport')"
              :edit-config="editConfigTransport"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <vxe-table-column type="checkbox" width="60"></vxe-table-column>
              <vxe-table-column
                type="index"
                width="60"
                :title="$t('table.index')"
              ></vxe-table-column>
              <vxe-table-column
                field="nameVoyageLicense"
                :title="$t('transportDeliveryOrder.form.transport.nameVoyageLicense')"
                :edit-render="{ name: 'ElInput', props: { clearable: true } }"
              ></vxe-table-column>
              <vxe-table-column
                field="freightInformation"
                :title="$t('transportDeliveryOrder.form.transport.freightInformation')"
                :edit-render="{ name: 'ElInput', props: { clearable: true } }"
              >
              </vxe-table-column>
              <vxe-table-column
                field="contactPerson"
                :title="$t('transportDeliveryOrder.form.transport.contactPerson')"
                :edit-render="{ name: 'ElInput', props: { clearable: true } }"
              >
              </vxe-table-column>
              <vxe-table-column
                field="contactPhoneNo"
                :title="$t('transportDeliveryOrder.form.transport.contactPhoneNo')"
                :edit-render="{ name: 'ElInput', props: { clearable: true } }"
              >
              </vxe-table-column>
              <vxe-table-column
                field="identityCardNumber"
                :title="$t('transportDeliveryOrder.form.transport.identityCardNumber')"
                :edit-render="{ name: 'ElInput', props: { clearable: true } }"
              >
              </vxe-table-column>
              <vxe-table-column
                field="mark"
                title="备注"
                :edit-render="{ name: 'ElInput', props: { clearable: true } }"
              >
              </vxe-table-column>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="6" v-if="this.formData.outboundStatus == '1'">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('transportDeliveryOrder.form.printHistory') }}</div
          >
        </template>
        <div class="collapse-content">
          <div class="tableStyle">
            <upload
              ref="upload"
              v-bind:tableData="attachmentCategoryDataList"
              :printShow="false"
              v-bind:isShow="false"
              @upDataHistory="getHistoryList"
              @upDataNo="getUpDataNo"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        v-if="this.outboundStatus != '2'"
        @click="save"
        v-hasPermi="['2021050814333827332']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        type="primary"
        @click="commit"
        v-hasPermi="['2021050814334810151']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('dialog.submit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  import DataBaseAPI from '@/api/dataBase';
  import formRules from './rules/rules';
  import column from './columns/columns';
  // import masterObj from '@/common/js/masterObj';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import upload from './component/upload';
  // import faxHistory from './component/faxHistory';

  export default {
    name: 'transportDeliveryOrderBaseEdit',
    components: {
      SearchModal,
      inputNumberAd,
      upload,
      // faxHistory,
    },
    data() {
      let params = this.$route.query || null;
      let newDate = new Date();
      newDate.setDate(newDate.getDate() + 3);
      //如果是前三天就-3
      // newDate.getDate();//得到后三天的时间
      return {
        outboundStatus: 0,
        outboundNo: null, //出库单号
        checked: [],
        load: false,
        canEdit: false, //时候禁用
        rules: formRules.formRules,
        flag: this.$route.query.flag,
        instructionTypeList: [], //交货方式
        deliveryMethodList: [],
        outboundTypeList: [],
        productNo: null, //选中商品行项目商品编码
        outboundStorageNo: null, //出库仓库编码
        goodColumnList: column.goodColumnList,
        transportColumnList: column.transportColumnList,
        feeRules: formRules.feeRules,
        goodRules: formRules.goodRules,
        transportRules: formRules.transportRules,
        tableToolbar: {},
        editConfig: { trigger: 'click', mode: 'row' },
        editConfigTransport: { trigger: 'click', mode: 'row' },
        lastCheckboxValue: '', //记录发货备注中多选框的值
        isIncludeOutboundExpense: 1,
        isInsureTypeList: [
          { id: '1', name: '否' },
          { id: '0', name: '是' },
        ],
        expenseTypeList: [],
        isTransfer: false,
        rowData: {
          fee: [],
          product: [],
          transport: [],
        },
        row: {
          fee: { expenseType: null, expenseRate: 0, outboundQuantity: 0, outboundExpense: 0 },
          transport: {
            deliveryType: '',
            nameVoyageLicense: '',
            freightInformation: '',
            contactPerson: '',
            contactPhoneNo: '',
            identityCardNumber: '',
            mark: '',
          },
        },
        rowIndex: {
          fee: 0,
          product: 0,
          transport: 0,
        },
        deleteRow: {
          fee: [],
          transport: [],
        },
        options: [
          this.$t('transportDeliveryOrder.form.checkbox1'),
          this.$t('transportDeliveryOrder.form.checkbox2'),
          this.$t('transportDeliveryOrder.form.checkbox3'),
          this.$t('transportDeliveryOrder.form.checkbox4'),
          this.$t('transportDeliveryOrder.form.checkbox5'),
        ],
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开那些面板，
        type: params ? params.type : '',
        formData: {
          customerNo: '',
          outboundPrintTime: 0,
          contactPerson: '',
          contactPersonName: '',
          returnAndChangeNo: '',
          storageContactPhone: '',
          outboundStorageName: '',
          outboundStorageNo: '',
          deliveryMethod: '',
          outboundType: '',
          outboundBusinessPerson: null,
          //deliveryMethod:this.$route.query.flag==0 ? params.
          deliveryNote: '',
          contactPhone: '',
          salesLadingNo: params && params.flag == 0 && params && params.no ? params.no : null,
          allotNo: params && params.flag == 1 && params && params.no ? params.no : null,
          outboundCreateTime: new Date(),
          validDateTo: newDate,
          outboundCreateDate: new Date(),
          outboundStatusName: '草稿',
          outboundStatus: '0',
          shippingMethod: '',
          includeOutboundExpenseData: '1',
          storageContactEmail: null,
          mark: '',
        },
        pickerEndOptions: {
          disabledDate: (time) => {
            let startDate = this.formData.outboundCreateTime;
            if (startDate) {
              return time.getTime() < new Date(startDate).getTime();
            }
          },
        },
        outboundStatusData: ['', '已保存', '已执行', '已撤销', '已删除'],
        attachmentCategoryDataList: [], //打印销售提货单历史
        faxList: [], //传真历史
        //partner:masterObj.customer,
        //warehouse:masterObj.warehouse,
        //person:masterObj.person
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //合作伙伴
      partner() {
        return {
          API: DataBaseAPI.PARTNER_LIST_API,
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          query: {
            requestStatus: 'ZT03',
            adminFlag: this.userInfo.userInfo.adminFlag,
          },
          searchColumns: [
            {
              name: window.vm.$t('cooperation.label.partnerZhName'),
              prop: 'partnerZhName',
              type: 'input',
            },
          ],
          columnList: [
            { prop: 'partnerZhName', label: window.vm.$t('cooperation.label.partnerZhName') },
            { prop: 'partnerCode', label: window.vm.$t('cooperation.label.partnerCode') },
            { prop: 'identityNo', label: window.vm.$t('cooperation.label.identityNo') },
            { prop: 'creditCode', label: window.vm.$t('cooperation.label.creditCode') },
            { prop: 'requestByName', label: window.vm.$t('cooperation.label.requestByName') },
            { prop: 'requestTime', label: window.vm.$t('cooperation.label.requestTime') },
            //   { prop: "requestStatus", label: window.vm.$t('cooperation.label.requestStatus') },
          ],
        };
      },
      //仓库
      warehouse() {
        return {
          propName: 'storageName', // 输入框展示内容
          propCode: 'storageCode',
          query: {
            storageCode: '',
            storageName: '',
            adminFlag: this.userInfo.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
            isDirectDeliver: '0',
          },
          searchColumns: [
            {
              prop: 'storageCode',
              name: window.vm.$t('warehouse.search.warehouseCode'),
              type: 'input',
              placeholder: window.vm.$t('warehouse.search.warehouseCodePlaceholder'),
            },
            {
              prop: 'storageName',
              name: window.vm.$t('warehouse.search.warehouseName'),
              type: 'input',
              placeholder: window.vm.$t('warehouse.search.warehouseNamePlaceholder'),
            },
          ],
          API: DataBaseAPI.STORAGE_LIST_API,
          columnList: [
            {
              prop: 'storageCode',
              label: window.vm.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: window.vm.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: window.vm.$t('warehouse.table.createWarehouseAddress'),
            },
            {
              prop: 'storageCompanyCode',
              label: window.vm.$t('warehouse.table.createWarehouseCompanyCode'),
            },
            {
              prop: 'storageCompanyName',
              label: window.vm.$t('warehouse.table.createWarehouseCompanyName'),
            },
            {
              prop: 'personName',
              label: window.vm.$t('warehouse.table.gmtCreateBy'),
            },
            {
              prop: 'storageCreateTime',
              label: window.vm.$t('warehouse.table.gmtCreate'),
            },
            // { prop: "currentStatus", label: window.vm.$t("warehouse.table.status") }
          ],
        };
      },

      //人员
      person() {
        return {
          API: DataBaseAPI.PERSON_LIST_API,
          propCode: 'id',
          propName: 'personName', // 输入框展示内容
          query: {
            userCompany: null,
            dataStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: window.vm.$t('personnel.search.personnelInformation'),
              prop: 'personInfo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'personNo',
              label: window.vm.$t('personnel.addpersonnel.personNo'),
              width: 100,
            },
            {
              prop: 'personName',
              label: window.vm.$t('personnel.table.Name'),
              width: 100,
            },
            {
              prop: 'personCompanyName',
              label: window.vm.$t('personnel.table.company'),
              width: 150,
            },
            {
              prop: 'personDepartmentName',
              label: window.vm.$t('personnel.table.department'),
            },
            {
              prop: 'personMobilePhone',
              label: window.vm.$t('personnel.table.phone'),
              width: 100,
            },
            {
              prop: 'personEmail',
              label: window.vm.$t('personnel.table.email'),
              width: 120,
            },
            {
              prop: 'dataStatus',
              label: window.vm.$t('personnel.table.dataState'),
              width: 100,
            },
          ],
        };
      },
      //业务入库批次
      transportList() {
        return {
          width: '800',
          query: {
            productNo: this.productNo,
            storageNo: this.outboundStorageNo,
            storageCompanyCode: this.userInfo.userInfo.companyCode,
            storageDepartmentCode: this.formData.outboundDepartmentNo,
          },
          API: API.GET_STORAGE_LIST,
          columnList: [
            {
              prop: 'batchNo',
              label: window.vm.$t('transportDeliveryOrder.transportList.batchNo'),
            },
            {
              prop: 'storageQuantity',
              label: window.vm.$t('transportDeliveryOrder.transportList.storageQuantity'),
            },
          ],
        };
      },
    },
    mounted() {
      if (this.$route.name === 'transportDeliveryOrderAdd') {
        let userInfo = this.userInfo.userInfo;
        this.formData.contactPersonName = userInfo.userName;
        this.formData.contactPerson = userInfo.userName;
        this.formData.companyCode = userInfo.companyCode;
        this.formData.companyName = userInfo.companyName;
        this.formData.departmentCode = userInfo.departmentCode;
        this.formData.departmentName = userInfo.departmentName;
        this.formData.outboundCreatePersonNo = userInfo.userCode;
        this.formData.outboundCreatePersonName = userInfo.userName;
        this.formData.outboundBusinessPersonNo = userInfo.userCode;
        this.formData.outboundBusinessPersonName = userInfo.userName;
        this.formData.contactPhone = userInfo.account;
      }
      this.getDic();
      this.getData(); //获取销售提单/库存调拨单详情
      // 初始化表格是否编辑
      this.editConfigTransport = !this.canEdit ? { trigger: 'click', mode: 'row' } : {};
    },
    methods: {
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //交货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'deliver_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.instructionTypeList = res.data.data;
            }
          });
        //出库类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'outgoing_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.outboundTypeList = res.data.data;
            }
          });
        //运输方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'delivery_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.deliveryMethodList = res.data.data;
            }
          });
        //费用类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'rate_types', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              // for (var item of res.data.data) {
              //     this.expenseTypeData[item["value"]] = item["label"]
              // }
              this.expenseTypeList = res.data.data;
            }
          });
      },
      getCustomerReceiveQuantity(val, row) {
        if (!val) {
          row.customerReceiveQuantity = 0;
        }
      },
      //获取销售提单/库存调拨单/采购退货详情
      getData() {
        if (this.$route.query.type == 1) {
          //修改
          let outboundNo = this.$route.query.outboundNo;
          this.outboundNo = this.$route.query.outboundNo;
          this.$axios.get(API.DETAIL_TRANSPORTDELIVERYORDER_API + outboundNo).then((res) => {
            if (0 == res.data.code) {
              this.formData = res.data.data;
              this.outboundStorageNo = res.data.data.outboundStorageNo;
              this.formData.outboundStatusName =
                this.outboundStatusData[this.formData.outboundStatus];
              this.outboundStatus = this.formData.outboundStatus;
              this.getHistoryList();
              if (this.outboundStatus == '2') {
                this.canEdit = true;
              }
              let flag = this.formData.includeOutboundExpense;
              this.isIncludeOutboundExpense = flag == true ? 0 : 1;
              this.formData.includeOutboundExpenseData = flag == true ? '是' : '否';
              this.rowData.fee = res.data.data.outBoundExpenseList;
              this.rowData.transport = res.data.data.deliveryTransportList;
              this.rowData.product = res.data.data.outboundDetailList.map((item) => {
                return {
                  ...item,
                  maxSendQuantity: item.businessOrderQuantity,
                  customerReceiveQuantity: item.customerReceiveQuantity || 0,
                };
              });
              if (this.formData.expenseMonthPay == true) {
                this.checked.push('出库费物产月结');
              }
              if (this.formData.expenseDriverPay == true) {
                this.checked.push('出库费司机支付');
              }
              if (this.formData.heatingAllowanceMonthPay == true) {
                this.checked.push('高温费物产月结');
              }
              if (this.formData.resubmitMonthPay == true) {
                this.checked.push('补单，出库费物产月结');
              }
              if (this.formData.resubmitDriverPay == true) {
                this.checked.push('补单，出库费司机支付');
              }
            }
          });
        } else {
          //新增
          let flag = this.$route.query.flag;
          let outboundNo = this.$route.query.no;
          if (flag == 0) {
            //获取销售提单详情
            this.formData.outboundType = 'CK01';
            this.getSalesLadingBill(outboundNo);
          } else if (flag == 1) {
            //获取调拨单详情
            this.isTransfer = true;
            this.formData.outboundType = 'CK02';
            this.getTransferData(outboundNo);
          } else {
            //采购退货
            this.formData.returnAndChangeNo = outboundNo;
            this.formData.outboundType = 'CK03';
            this.getReturnData(outboundNo);
          }
        }
      },
      //获取销售提单详情
      getSalesLadingBill(no) {
        this.$axios.post(API.GET_DATA_DETAIL, { ladingNo: no, outboundFlag: 1 }).then((res) => {
          if (0 == res.data.code) {
            let data = res.data.data;
            this.formData.salesLadingNo = data.ladingNo || data.salesLadingNo;
            //this.formData.deliveryMethod = data.returnMethod
            if (data.deliveryMethod == 'JHFS01') {
              this.formData.deliveryMethod = 'JHFS01';
            } else if (data.deliveryMethod == 'JHFS02') {
              this.formData.deliveryMethod = 'JHFS02';
            } else if (data.deliveryMethod == 'JHFS03') {
              this.formData.deliveryMethod = 'JHFS03';
            } else if (data.deliveryMethod == 'JHFS07') {
              this.formData.deliveryMethod = 'JHFS07';
            }
            //this.formData.contactPerson = data.receiver
            //this.formData.contactPersonName = data.receiver
            //this.formData.contactPhone = data.receiverPhone
            this.formData.outboundStorageNo = data.storageNo;
            this.outboundStorageNo = data.storageNo;
            this.formData.outboundStorageName = data.storageName;
            this.formData.outboundBusinessPersonNo = data.ladingSalesmanNo;
            this.formData.outboundBusinessPersonName = data.ladingSalesmanName;
            this.formData.customerNo = data.customerNo;
            this.formData.customerName = data.customerName;
            this.formData.outboundDepartmentNo = data.ladingBusinessDepartmentNo;
            this.formData.outboundDepartmentName = data.ladingBusinessDepartmentName;
            this.formData.shippingMethod = data.shippingMethod;
            this.formData.mark = data.mark;
            this.getWareHousePhone(data.storageNo);
            this.getHistoryList();
            if (
              data.storageLadingPickingDetailListForOutbound &&
              data.storageLadingPickingDetailListForOutbound.length > 0
            ) {
              let list = [];
              data.storageLadingPickingDetailListForOutbound.map((item, index) => {
                list.push({
                  outboundDetailNo: index + 1,
                  productNo: item.productNo,
                  productName: item.productDesc,
                  productUnit: item.unit,
                  productUnitName: item.ladingUnitName,
                  businessOrderQuantity: item.pickingQuantity,
                  maxSendQuantity: item.actualOutQuantity,
                  remainingOutQuantity: item.actualOutQuantity,
                  storageQuantity: 0,
                  preNo: item.ladingNo,
                  preDetailNo: item.ladingDetailNo,
                  contractNo: item.contractNo,
                  contractDetailNo: item.contractDetailNo,
                  nameVoyageLicense: data.nameVoyageLicense,
                  storageShouldSendQuantity: item.actualOutQuantity,
                  storageSendQuantity: item.actualOutQuantity,
                  storageSendPackage: item.storageShouldSendPackage,
                  distributionBatchNo: item.distributionBatchNo,
                  customerReceiveQuantity: item.actualOutQuantity || 0,
                  shipComplete: 'N',
                });
              });
              this.rowData.product = list;
            }
            if (
              this.formData.deliveryMethod == 'JHFS01' ||
              this.formData.deliveryMethod == 'JHFS05'
            ) {
              this.rowData.transport = data.storageLadingShippingDetailList.map((item) => {
                return {
                  nameVoyageLicense: item.nameVoyageLicense,
                  contactPerson: item.driverName,
                  contactPhoneNo: item.contactPhoneNo,
                  freightInformation: '',
                  identityCardNumber: item.identityCardNo,
                  mark: item.mark,
                };
              });
            }
          }
        });
      },
      //获取调拨单详情-调拨单不存在客户自提情况
      getTransferData(no) {
        this.$axios.get(API.DETAIL_API, { allotNo: no, isShowAll: 0 }).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data;
            this.formData.allotNo = data.allotNo || data.salesLadingNo;
            //this.formData.deliveryMethod = data.allotMethod
            if (data.allotMethod == 'DBFS01') {
              this.formData.deliveryMethod = 'JHFS02';
            } else {
              this.formData.deliveryMethod = 'JHFS03';
            }
            //this.formData.contactPerson = data.allotCreatePersonNo
            //this.formData.contactPersonName = data.allotCreatePersonName
            this.formData.outboundStorageNo = data.allotOutStorageNo;
            this.outboundStorageNo = data.allotOutStorageNo;
            this.formData.outboundStorageName = data.allotOutStorage;
            this.formData.outboundDepartmentNo = data.allotDepartmentNo;
            this.formData.outboundDepartmentName = data.allotDepartmentName;
            this.formData.shippingMethod = data.shippingMethod;
            this.getWareHousePhone(data.allotOutStorageNo);
            this.getHistoryList();
            if (data.storageAllotDetailVOs && data.storageAllotDetailVOs.length > 0) {
              let list = data.storageAllotDetailVOs.map((item, index) => {
                return {
                  outboundDetailNo: index + 1,
                  productNo: item.productDetailNo,
                  productName: item.productName,
                  productUnit: item.allotUnit,
                  productUnitName: item.allotUnitName,
                  businessOrderQuantity: item.allotOutAmount,
                  maxSendQuantity: item.surplusQuantity,
                  remainingOutQuantity: item.surplusQuantity,
                  businessOrderPackage: item.allotOutPackage,
                  storageQuantity: 0,
                  preNo: item.allotNo,
                  preDetailNo: item.allotDetailNo,
                  nameVoyageLicense: data.nameVoyageLicense,
                  storageSendQuantity: item.surplusQuantity,
                  storageSendPackage: item.storageShouldSendPackage,
                  storageShouldSendQuantity: item.surplusQuantity,
                  distributionBatchNo: item.distributionBatchNo,
                  customerReceiveQuantity: item.surplusQuantity || 0,
                };
              });
              this.rowData.product = list;
            }
            //this.rowData.transport = this.formData.distributionAllotTransportVOs
          }
        });
      },
      //获取采购退货详情
      getReturnData(no) {
        this.$axios.get(API.DETAIL_FOR_TRANSPORT + no).then((res) => {
          if (0 == res.data.code) {
            let data = res.data.data;
            this.formData.returnAndChangeNo = data.returnNo || data.returnAndChangeNo;
            //this.formData.deliveryMethod = data.returnMethod
            if (data.returnMethod == 'THFS01') {
              this.formData.deliveryMethod = 'JHFS01';
            } else if (data.returnMethod == 'THFS01') {
              this.formData.deliveryMethod = 'JHFS02';
            } else {
              this.formData.deliveryMethod = 'JHFS03';
            }
            //this.formData.contactPerson = data.returnOperatorNo
            //this.formData.contactPersonName = data.returnOperatorName
            this.formData.outboundStorageNo = data.outboundStorageCode;
            this.outboundStorageNo = data.outboundStorageCode;
            this.formData.outboundStorageName = data.outboundStorageName;
            this.formData.outboundBusinessPersonNo = data.returnSalesmanNo;
            this.formData.outboundBusinessPersonName = data.returnSalesmanName;
            this.formData.customerNo = data.partnerCode;
            this.formData.customerName = data.partnerName;
            this.formData.outboundDepartmentNo = data.returnDepartmentCode;
            this.formData.outboundDepartmentName = data.returnDepartmentName;
            this.getWareHousePhone(data.outboundStorageCode);
            this.getHistoryList();
            if (data.purchaseReturnDetailList && data.purchaseReturnDetailList.length > 0) {
              let list = data.purchaseReturnDetailList.map((item, index) => {
                return {
                  outboundDetailNo: index + 1,
                  productNo: item.productCode,
                  productName: item.productName,
                  productUnit: item.productUnit,
                  productUnitName: item.productUnitName,
                  businessOrderQuantity: item.returnQuantity,
                  maxSendQuantity: item.restOutboundQuantity,
                  remainingOutQuantity: item.restOutboundQuantity,
                  storageShouldSendQuantity: item.restOutboundQuantity,
                  storageSendQuantity: item.restOutboundQuantity,
                  storageQuantity: 0,
                  preNo: item.returnNo,
                  preDetailNo: item.returnDetailNo,
                  nameVoyageLicense: data.nameVoyageLicense,
                  storageSendPackage: item.storageShouldSendPackage,
                  distributionBatchNo: item.distributionBatchNo,
                  customerReceiveQuantity: item.restOutboundQuantity || 0,
                };
              });
              this.rowData.product = list;
            }
          }
        });
      },
      getHistoryList() {
        let params = {
          dataType: 'DISTRIBUTION_OUTBOUND',
          dataNo: this.formData.outboundNo,
          attachmentCategory: '1',
        };
        this.$axios.post(API.HISTORY_LIST_ATTACHMENT_PAGE, params).then((res) => {
          if (res.data.code == 0) {
            this.attachmentCategoryDataList = res.data.data;
          }
        });
      },
      //次数打印
      getUpDataNo(row) {
        let params = {
          attachmentId: row.attachmentId,
        };
        this.$axios.post(API.ADD_PRINT_NUMBER, params).then((res) => {
          if (res.data.code == 0) {
            this.getHistoryList();
          }
        });
      },
      //交货方式
      instructionType(deliveryMethod) {
        //交货方式为客户自提时，运输方式引用前序
        if (this.$route.query.type != 1 && deliveryMethod == 'JHFS01') {
          let outboundNo = this.$route.query.no;
          //销售
          if (this.formData.outboundType == 'CK01') {
            this.$axios
              .post(API.GET_DATA_DETAIL, { ladingNo: outboundNo, outboundFlag: 1 })
              .then((res) => {
                if (0 == res.data.code) {
                  let data = res.data.data;
                  this.formData.shippingMethod = data.shippingMethod;
                  this.rowData.transport = data.storageLadingShippingDetailList.map((item) => {
                    return {
                      nameVoyageLicense: item.nameVoyageLicense,
                      contactPerson: item.driverName,
                      contactPhoneNo: item.contactPhoneNo,
                      freightInformation: '',
                      identityCardNumber: item.identityCardNo,
                      mark: item.mark,
                    };
                  });
                }
              });
          } else if (this.formData.outboundType == 'CK03') {
            //采购
            this.$axios.post(API.DETAIL_FOR_TRANSPORT + outboundNo).then((res) => {
              if (0 == res.data.code) {
                let data = res.data.data;
                this.formData.shippingMethod = data.shippingMethod;
                this.rowData.transport = data.storageLadingShippingDetailList.map((item) => {
                  return {
                    nameVoyageLicense: item.nameVoyageLicense,
                    contactPerson: item.driverName,
                    contactPhoneNo: item.contactPhoneNo,
                    freightInformation: '',
                    identityCardNumber: item.identityCardNo,
                    mark: item.mark,
                  };
                });
              }
            });
          }
        }
      },
      //查询仓库联系方式
      getWareHousePhone(outboundStorageCode) {
        if (outboundStorageCode) {
          this.$axios.get(API.GET_STORAGE_DETAIL_API + outboundStorageCode).then((res) => {
            if (0 == res.data.code) {
              if (res.data.data.contactTelephone) {
                this.formData.storageContactPhone = res.data.data.contactTelephone;
                this.formData.storageContactEmail = res.data.data.email;
              }
            }
          });
        }
      },
      //修改开单日期
      changeCreatTime(val) {
        let newDate = new Date(val);
        newDate.setDate(newDate.getDate() + 3);
        //如果是前三天就-3
        // newDate.getDate();//得到后三天的时间
        this.formData.validDateTo = newDate;
      },
      //选择联系人
      setContactPerson(val, row) {
        if (row) {
          this.formData.contactPerson = row[0].personName;
          this.formData.contactPersonName = row[0].personName;
          this.formData.contactPhone = row[0].personMobilePhone;
        }
      },
      //选择业务员
      setBusinessPerson(val, row) {
        if (row.length > 0) {
          this.formData.outboundBusinessPersonNo = row[0].id || null;
          this.formData.outboundBusinessPersonName = row[0].personName || null;
        }
      },
      //选择仓库
      setWareHouse(val, row) {
        if (row.length > 0) {
          this.formData.outboundStorageNo = row[0].storageCode;
          this.outboundStorageNo = row[0].storageCode;
          this.formData.outboundStorageName = row[0].storageName;
          this.formData.storageContactPhone = row[0].contactTelephone;
          this.formData.storageContactEmail = row[0].email;
        }
        if (this.$refs.product.getActiveRecord()) {
          this.$refs.product.clearActived();
        }
      },
      //选择客户
      setCustomer(val, row) {
        if (row.length > 0) {
          this.formData.customerNo = row[0].partnerCode;
          this.formData.customerName = row[0].partnerZhName;
        }
      },
      //获取部门列表
      getBusinessDepartmentList() {},
      //checkbox选择与取消选择
      handleChecked(value) {
        if (!this.formData.deliveryNote) {
          this.formData.deliveryNote = '';
        }
        // let deliveryNote = this.formData.deliveryNote;
        let checkboxValue = value.join(',');
        this.formData.deliveryNote = checkboxValue;
      },
      //修改是否含出库费
      changeValue(value) {
        this.isIncludeOutboundExpense = value;
        if (this.isIncludeOutboundExpense == 0) {
          this.rowData.fee.push(JSON.parse(JSON.stringify(this.row.fee)));
          //this.rowData.fee = []
        }
      },
      //计算费用
      changeAmount(val) {
        if (val !== '') {
          let params = {
            returnQuantity: this.rowData.fee[this.rowIndex.fee].outboundQuantity,
            returnUnitPrice: this.rowData.fee[this.rowIndex.fee].expenseRate,
          };
          this.$axios.post(API.GET_AMOUNT, params).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data;
              this.rowData.fee[this.rowIndex.fee].outboundExpense = data.returnMoneyAmount;
            }
          });
        } else {
          this.rowData.fee[this.rowIndex.fee].outboundExpense = 0;
        }
      },
      // 仓库应发数量
      changeSent(val, row) {
        row.storageSendQuantity = val;
      },
      //仓库应发件树木
      changeSentPack(val, row) {
        row.storageSendPackage = val;
      },
      //新增行
      addRow(type) {
        if (!this.rowData[type]) {
          this.rowData[type] = [];
        }
        this.rowData[type].push(JSON.parse(JSON.stringify(this.row[type])));
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          this.$message({ showClose: true, message: '您还没选择想要删除的数据', type: 'error' });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              this.deleteRow[tableTpye].push(item.id);
            });
            this.$refs[tableTpye].removeSelecteds();

            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
            this.rowData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancle') });
          });
      },
      //点击表格记录正在编辑哪一行
      rowClick(value, type) {
        this.rowIndex[type] = value.$rowIndex;
        if (type == 'product') {
          this.productNo = this.rowData.product[this.rowIndex.product].productNo;
        }
      },
      //选择物流批次
      setTransportNo(model, value, row) {
        console.log(model, value, row);
        if (value) {
          this.rowData.product[this.rowIndex.product].distributionBatchNo = value[0].batchNo;
          this.rowData.product[this.rowIndex.product].storageQuantity = value[0].storageQuantity; //物流批次数量
          if (
            value[0].storageQuantity &&
            parseFloat(value[0].storageQuantity) <
              parseFloat(this.rowData.product[this.rowIndex.product].maxSendQuantity)
          ) {
            this.rowData.product[this.rowIndex.product].maxSendQuantity = value[0].storageQuantity;
          }
          this.$refs.product.updateData();
        } else {
          this.rowData.product[this.rowIndex.product].distributionBatchNo = '';
          this.rowData.product[this.rowIndex.product].storageQuantity = ''; //物流批次数量
        }
      },
      //计算费用
      calculate(val, type) {
        let index = this.rowIndex.fee;
        let expenseRate = this.rowData.fee[index].expenseRate;
        let outboundQuantity = this.rowData.fee[index].outboundQuantity;
        if (type == 0) {
          expenseRate = val;
        } else {
          outboundQuantity = val;
        }
        let outboundExpense = this.$cal.calCommon(expenseRate, outboundQuantity, '*', 'amount');
        this.rowData.fee[index].expenseRate = expenseRate || 0;
        this.rowData.fee[index].outboundQuantity = outboundQuantity || 0;
        this.rowData.fee[index].outboundExpense = outboundExpense || 0;
      },
      //保存/提交
      save() {
        if (
          !(this.formData.salesLadingNo || this.formData.allotNo || this.formData.returnAndChangeNo)
        ) {
          this.$message({
            showClose: true,
            message: this.$t('transportDeliveryOrder.msg.selectType'),
            type: 'error',
          });
          return;
        }
        if (!this.formData.outboundStorageNo || !this.formData.outboundStorageName) {
          this.$message({
            showClose: true,
            message: this.$t('transportDeliveryOrder.msg.selectWareHouse'),
            type: 'error',
          });
          return;
        }
        let list = ['formData', 'fee', 'product', 'transport'];
        let resultArr = [];
        let _self = this;
        let validates = function (formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          });
          resultArr.push(result);
        };
        list.map((item) => {
          return validates(item);
        });
        Promise.all(resultArr).then(() => {
          this.saveData(1);
        });
      },
      //提交
      commit() {
        let list = ['formData', 'fee', 'product', 'transport'];
        let resultArr = [];
        let _self = this;
        let validates = function (formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          });
          resultArr.push(result);
        };
        list.map((item) => {
          return validates(item);
        });
        Promise.all(resultArr).then(() => {
          //遍历商品列表，判断实出数量最小值-最小值大于仓库应发数量-仓库应发数量*0.1
          let product = _self.$refs.product.getTableData().fullData;
          let flag = 1; //判断仓库实发最小值标记 1:成功 0:失败
          /* if(product && product.length > 0){
                  product.map((item,index)=>{
                      let storageShouldSendQuantity = item.storageShouldSendQuantity
                      let storageSendQuantity = item.storageSendQuantity
                      let minNum = this.$cal.calCommon(item.storageShouldSendQuantity,0.9, '*')
                      if(parseFloat(storageSendQuantity) < parseFloat(minNum)){
                          flag = 0
                      }
                  })
              } */
          if (flag == 1) {
            let flagRemainingOutQuantity = 1;
            if (this.outboundStatus == '2') {
              this.saveData(2);
              return;
            }
            product.map((item) => {
              if (Number(item.storageShouldSendQuantity) > Number(item.remainingOutQuantity)) {
                flagRemainingOutQuantity = 0;
              }
            });
            if (flagRemainingOutQuantity == 1) {
              this.saveData(2);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('transportDeliveryOrder.msg.remainingOutQuantity'),
                type: 'error',
              });
            }
          } else {
            this.$message({
              showClose: true,
              message: this.$t('transportDeliveryOrder.msg.storageSendQuantityNum'),
              type: 'error',
            });
          }
        });
        // this.$refs.formData.validate((valid)=>{
        //     if(valid){
        //         //判断商品数量
        //         this.$refs.product.validate((valid)=>{
        //             if(valid){
        //                 //运输方式，客户自体引用前序单据的运输信息
        //                 this.$refs.transport.validate((valid)=>{
        //                     if(valid){
        //                         //运输方式，客户自体引用前序单据的运输信息
        //                         this.saveData(2)
        //                     }
        //                 })
        //             }

        //         })
        //     }
        // })
      },
      //提交 前判断是否完全发货(提单生成this.formData.outboundType = 'CK01'  提交时才校验)
      saveData(status) {
        if (this.formData.outboundType == 'CK01' && status == '2') {
          let completeList = []; //完全发货行
          let notCompleteList = []; //未完全发货行
          this.rowData.product.map((item, index) => {
            //剩余应出数量-remainingOutQuantity 仓库应发数量-storageShouldSendQuantity
            if (item.remainingOutQuantity == item.storageShouldSendQuantity) {
              completeList.push(index + 1);
            } else {
              notCompleteList.push(index + 1);
            }
          });
          if (completeList.length > 0) {
            let msg = '是否各行均完全发货？';
            if (notCompleteList.length > 0)
              msg = '第' + notCompleteList.join(',') + '行没有完全发货';
            this.$confirmAction('完全发货提示', msg, '是', '否')
              .then(() => {
                this.rowData.product = this.rowData.product.map((item) => {
                  item['shipComplete'] = 'Y';
                  return item;
                });
                this.submitData(status);
              })
              .catch((action) => {
                if (action === 'cancel') {
                  this.rowData.product = this.rowData.product.map((item) => {
                    item['shipComplete'] = 'N';
                    return item;
                  });
                  this.submitData(status);
                }
              });
          } else {
            // 全部都是未完全发货 不用提示
            this.rowData.product = this.rowData.product.map((item) => {
              item['shipComplete'] = 'N';
              return item;
            });
            this.submitData(status);
          }
        } else {
          this.submitData(status);
        }
      },
      submitData(status) {
        this.load = true;
        let data = this.formData;
        data.outboundStatus = status;
        data.includeOutboundExpense = data.includeOutboundExpenseData == '1' ? false : true;
        data.expenseMonthPay = false;
        data.expenseDriverPay = false;
        data.heatingAllowanceMonthPay = false;
        data.resubmitMonthPay = false;
        data.resubmitDriverPay = false;
        if (this.checked.length > 0) {
          this.checked.map((item) => {
            if (item === '出库费物产月结') {
              data.expenseMonthPay = true;
            }
            if (item === '出库费司机支付') {
              data.expenseDriverPay = true;
            }
            if (item === '高温费物产月结') {
              data.heatingAllowanceMonthPay = true;
            }
            if (item === '补单，出库费物产月结') {
              data.resubmitMonthPay = true;
            }
            if (item === '补单，出库费司机支付') {
              data.resubmitDriverPay = true;
            }
          });
        }
        let url = '';
        this.$refs.product.clearActived();
        if (this.outboundNo) {
          url = API.EDIT_TRANSPORTDELIVERYORDER_API; //修改
          data.updateDistributionOutboundDetailStr = JSON.stringify(this.rowData.product);
        } else {
          url = API.ADD_TRANSPORTDELIVERYORDER_API; //新增
          data.distributionOutboundDetailStr = JSON.stringify(this.rowData.product);
        }
        let insertFee = [];
        let updateFee = [];
        if (this.rowData.fee && this.rowData.fee.length > 0) {
          this.rowData.fee.map((item, index) => {
            item.outboundExpenseDetailNo = index + 1;
            if (item.outboundNo) {
              updateFee.push(item);
            } else {
              insertFee.push(item);
            }
          });
        }
        data.outBoundExpenseStr = JSON.stringify(insertFee);
        data.updateOutBoundExpenseStr = JSON.stringify(updateFee);

        let insertTransport = [];
        let updateTransport = [];
        if (this.rowData.transport && this.rowData.transport.length > 0) {
          this.rowData.transport.map((item) => {
            if (item.deliveryNo) {
              updateTransport.push(item);
            } else {
              insertTransport.push(item);
            }
          });
        }
        data.deliveryTransportStr = JSON.stringify(insertTransport);
        data.updateDeliveryTransportStr = JSON.stringify(updateTransport);
        data.deleteDeliveryTransportList = this.deleteRow.transport;
        data.deleteOutBoundExpenseList = this.deleteRow.fee;
        data.outboundDetailList = this.rowData.product;
        this.$axios.post(url, data).then((res) => {
          if (0 == res.data.code) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            if (status == 1) {
              if (this.$route.name == 'transportDeliveryOrderAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getData();
              }
            } else {
              this.toPath(res.data.data);
            }
            this.load = false;
          } else {
            this.load = false;
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/logistics/transportDeliveryOrderAdd',
            name: 'transportDeliveryOrderAdd',
            meta: {
              keepAlive: true,
              title: this.$t('transportDeliveryOrder.label.logisticsAdded'),
            },
          },
          toPath: {
            path: '/logistics/transportDeliveryOrderDetail',
            name: 'transportDeliveryOrderDetail',
            meta: {
              keepAlive: false,
            },
            query: {
              outboundNo: value.outboundNo,
              flag: value.outboundType === 'CK01' ? '0' : value.outboundType === 'CK02' ? '1' : '2',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      toPath(value) {
        let path = {
          fromPath: {
            path: `/logistics/${this.$route.name}`,
            name: `${this.$route.name}`,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/transportDeliveryOrderDetail',
            name: 'transportDeliveryOrderDetail',
            meta: {
              keepAlive: false,
            },
            query: {
              outboundNo: value.outboundNo,
              flag: '0',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //撤销/删除
      updateOutboundStatus(status) {
        let params = {
          outboundNo: this.formData.outboundNo,
          outboundStatus: status,
          version: this.formData.version,
        };
        let content = '';
        let title = '';
        if (status == 3) {
          title = this.$t('confirm.revert');
          content = this.$t('confirm.revertContent');
        } else {
          title = this.$t('confirm.delete');
          content = this.$t('confirm.content');
        }
        this.$confirmAction(title, content)
          .then(() => {
            this.$axios.post(API.DELETE_TRANSPORTDELIVERYORDER_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
    },
    watch: {
      // 判断表格编辑功能是否禁用
      canEdit: function (newQuestion) {
        this.editConfigTransport = !newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
  .collapse-last-content {
    margin-top: 10px;
  }
</style>
